import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout/products/openclaw-custom-development')(
  {
  },
);
